import { render, staticRenderFns } from "./List-Users.vue?vue&type=template&id=af049804"
import script from "./List-Users.vue?vue&type=script&lang=js"
export * from "./List-Users.vue?vue&type=script&lang=js"
import style0 from "./List-Users.vue?vue&type=style&index=0&id=af049804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports